// src/pages/admin/SeriesEditPage.js
import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import SeriesForm from "./organisms/SeriesForm";

const SeriesEditPage = () => {
  const { id } = useParams();
  const [seriesData, setSeriesData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSeries = async () => {
      const seriesDocRef = doc(db, "series", id);
      const seriesDoc = await getDoc(seriesDocRef);
      if (seriesDoc.exists()) {
        setSeriesData({ id: seriesDoc.id, ...seriesDoc.data() });
      } else {
        console.error("No such series!");
      }
    };
    fetchSeries();
  }, [id]);

  const handleUpdate = async (data) => {
    const seriesDocRef = doc(db, "series", id);
    await updateDoc(seriesDocRef, {
      ...data,
      updatedAt: serverTimestamp(),
    });
    alert("Series updated successfully");
    navigate("/admin");
  };

  if (!seriesData) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Container maxWidth="md">
      <Typography variant="h4" sx={{ my: 2 }}>
        Series Management
      </Typography>
      <SeriesForm
        initialData={seriesData}
        onSubmit={handleUpdate}
        isEdit={true}
      />
    </Container>
  );
};

export default SeriesEditPage;
